import { useRef, useCallback, useEffect } from 'react';

export default (
  callbackParam: () => void,
  isActive: boolean,
): ((node: any) => void) => {
  const observer = useRef<IntersectionObserver | null>(null);

  const callback = useCallback(
    (entries) => {
      if (entries.length === 0) {
        return;
      }

      if (entries[0].isIntersecting && isActive) {
        callbackParam();
      }
    },
    [callbackParam, isActive],
  );

  const infiniteScrollRef = useCallback(
    (node) => {
      if (!node || typeof IntersectionObserver !== 'function') {
        return;
      }

      observer.current?.disconnect();

      observer.current = new IntersectionObserver(callback);
      observer.current.observe(node);
    },
    [callback],
  );

  useEffect(() => {
    return () => observer.current?.disconnect();
  }, []);

  return infiniteScrollRef;
};
